import { components } from "@/api-schema";
import { commonColumns } from "./_constants/common-columns";

export type CompanyGroupTableType = components["schemas"]["CompanyGroup"];

export const companyGroupTableDefaultColumns = {
  columnName: commonColumns.columnName<CompanyGroupTableType>(),
  columnTechnicalId: commonColumns.columnTechnicalId<CompanyGroupTableType>(),
  columnUuid: commonColumns.columnUuid<CompanyGroupTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<CompanyGroupTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<CompanyGroupTableType>(),
};
